/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-06-10 15:25:28
 */

import * as request from '@/utils/request'
const BASE_URL = 'v1/manage/common/announcement'
export default {
  /**
   * createAnnounce
   * @description 创建公告
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  createAnnounce(data) {
    return request.post(`${BASE_URL}/create`, data)
  },
  /**
   * announceList
   * @description 公告列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  announceList(data) {
    return request.get(`${BASE_URL}`, data)
  },
  /**
   * goBackAnnounce
   * @description 回填数据
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  goBackAnnounce(data) {
    return request.get(`${BASE_URL}/${data}`,)
  },
  /**
   * goBackAnnounce
   * @description 修改状态
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  updateAnnounceStatus(id,data) {
    return request.post(`${BASE_URL}/setStatus/${id}`,data)
  },
  /**
   * editAnnounce
   * @description 编辑公告
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  editAnnounce(id,data) {
    return request.put(`${BASE_URL}/${id}`, data)
  },
  /**
   * deleteAnnounce
   * @description 删除公告
   * @author YQ
   * @date 2019-01-19
   * @param {*} id
   * @returns
   */
  deleteAnnounce(id) {
    return request.Delete(`${BASE_URL}/${id}`)
  }
}